<template>
  <div>
    <h1>Carga de Padrón</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <label>Documento (adjuntar archivo .xls)</label>
              <b-form-file
                v-model="$v.preferent.file.$model"
                ref="file"
                :state="fileState"
                placeholder="Archivo"
                browse-text="Adjuntar"
                drop-placeholder="Drop file here..."
                @change="onFileSelected"
                required
                accept=".xlsx, .xls"
                ></b-form-file>
            </div>
            <b-table
              show-empty
              stacked="md"
              :items="rows"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              empty-text="No existen registros por mostrar"
              emptyFilteredText="No existen registros por mostrar"
            >
            </b-table>
            <div class="col-12" style="margin-top: 2%">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="!( !$v.$invalid)">
                  Registrar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
import * as XLSX from 'xlsx'

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      preferent: {
        file: null,
      },
      fields: [
        { key: 'license', label: 'Licencia' },
        { key: 'date', label: 'Fecha De Vencimiento' },
      ],
      currentPage: 1,
      perPage: 20,
      rows: [],
      fileState: null,
      createdBy: this.$store.state.user.email,
    }
  },
  methods: {
    onFileSelected(event) {
      this.preferent.file = event.target.files[0]
      // console.log(this.preferent.file.name, 'file')
      const reader = new FileReader()
      if (reader.readAsBinaryString) {
        reader.onload = () => {
          const data = reader.result
          const workbook = XLSX.read(data, { type: 'binary', cellText: false, cellDates: true })
          const firstSheet = workbook.SheetNames[0]
          const excelRows = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet], { raw: false, dateNF: 'yyyy-mm-dd' })
          const values = excelRows.map((row) => {
            return { license: row.Licencia, date: row['Fecha De Vencimiento'] }
          })
          this.rows = values
        }
        reader.readAsBinaryString(event.target.files[0])
      }
    },
    async handleSubmit() {
      let i = 1
      await this.rows.forEach((row) => {
        this.$apollo.mutate({
          mutation: gql`mutation createPreferentialEntrys($license: String, $expirationDate: String) {
        createPreferentialEntrys(entrys: {
          license: $license
          expirationDate: $expirationDate
        }
        ){
          message
        }
        }`,
          context: headers(),
          variables: {
            license: row.license,
            expirationDate: row.date,
          },
        }).then(res => {
          console.log(i, ' es la i ')
          console.log(this.rows.length, 'length')
          console.log(row.license, 'license')
          if (i === this.rows.length) {
            this.$router.push('/pasajeros')
          }
          i++
        }).catch(error => {
          console.log(error)
        })
      })
    },
  },
  validations: {
    preferent: {
      file: { required },
    },
  },
}
</script>
